<mat-expansion-panel [expanded]="false" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ labels.title }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    @if(showNameFilter || showNumberFilter) {
      <div class="flex">
        @if (showNameFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ labels.name }}</mat-label>
            <input matInput [formControlName]="'name'" [placeholder]="labels.name" />
          </mat-form-field>
        }
        @if (showNumberFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ labels.number }}</mat-label>
            <input matInput [formControlName]="'number'" [placeholder]="labels.number" />
          </mat-form-field>
        }
      </div>
    }

    <div class="flex">
    </div>

    @if(showStatusFilter || showJurisdictionFilter) {
      <div class="flex">
        @if (showStatusFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-select formControlName="status" [placeholder]="labels.status" multiple="true">
              @for (option of statuses; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (showJurisdictionFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-select formControlName="jurisdiction" [placeholder]="labels.jurisdiction" multiple="true">
              @for (option of jurisdictions; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    }

    @if (showCompanyTypeFilter || showDescriptionFilter || showJurisdictionStatusFilter) {
      <div class="flex">
        @if (showCompanyTypeFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-select formControlName="companyType" [placeholder]="'businessSearchResultsFilter.companyType' | transloco" multiple="true">
              @for (option of types; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (showDescriptionFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-select formControlName="description" [placeholder]="'common.labels.description' | transloco" multiple="true">
              @for (option of descriptions; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if(showJurisdictionStatusFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-select formControlName="jurisdictionStatus" [placeholder]="'businessSearchResultsFilter.jurisdictionStatus' | transloco" multiple="true">
              @for (option of jurisdictionStatuses; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    }

    @if (showStatusDateFromFilter || showStatusDateToFilter) {
      <div class="flex">
        @if (showStatusDateFromFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'businessSearchResultsFilter.statusDateFrom' | transloco }}</mat-label>
            <input matInput [matDatepicker]="statusDateFrom" [formControlName]="'statusDateFrom'"
              [placeholder]="'businessSearchResultsFilter.statusDateFrom' | transloco">
            <mat-datepicker-toggle matSuffix [for]="statusDateFrom"></mat-datepicker-toggle>
            <mat-datepicker #statusDateFrom></mat-datepicker>
          </mat-form-field>
        }
        @if (showStatusDateToFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'businessSearchResultsFilter.statusDateTo' | transloco }}</mat-label>
            <input matInput [matDatepicker]="statusDateTo" [formControlName]="'statusDateTo'"
              [placeholder]="'businessSearchResultsFilter.statusDateTo' | transloco">
            <mat-datepicker-toggle matSuffix [for]="statusDateTo"></mat-datepicker-toggle>
            <mat-datepicker #statusDateTo></mat-datepicker>
          </mat-form-field>
        }
      </div>
    }

    @if (showCreationDateFromFilter || showCreationDateToFilter) {
      <div class="flex">
        @if (showCreationDateFromFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'businessSearchResultsFilter.creationDateFrom' | transloco }}</mat-label>
            <input matInput [matDatepicker]="creationDateFrom" [formControlName]="'creationDateFrom'"
              [placeholder]="'businessSearchResultsFilter.creationDateFrom' | transloco">
            <mat-datepicker-toggle matSuffix [for]="creationDateFrom"></mat-datepicker-toggle>
            <mat-datepicker #creationDateFrom></mat-datepicker>
          </mat-form-field>
        }
        @if (showCreationDateToFilter) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'businessSearchResultsFilter.creationDateTo' | transloco }}</mat-label>
            <input matInput [matDatepicker]="creationDateTo" [formControlName]="'creationDateTo'"
              [placeholder]="'businessSearchResultsFilter.creationDateTo' | transloco">
            <mat-datepicker-toggle matSuffix [for]="creationDateTo"></mat-datepicker-toggle>
            <mat-datepicker #creationDateTo></mat-datepicker>
          </mat-form-field>
        }
      </div>
    }

    @if(showHiddenFilter) {
      <div class="flex">
        <mat-radio-group formControlName="showResult" class="flex-item">
          <mat-radio-button [value]="false">{{ 'businessSearchResultsFilter.hidden' | transloco }}</mat-radio-button>
          <mat-radio-button [value]="null">{{ 'businessSearchResultsFilter.both' | transloco }}</mat-radio-button>
          <mat-radio-button [value]="true">{{ 'businessSearchResultsFilter.shown' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    <div class="spacer-small"></div>
    <div class="flex-container-right-align">
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ labels.clearFilters }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ labels.filter }}
      </button>
    </div>
  </form>
</mat-expansion-panel>